import React from "react";
import "./ManufacturingFeature.css";
import { Factory, Code, Wheat } from "lucide-react";

export default function IndustriesWeServe() {
  const points = [
    {
      title: "Agriculture",
      description:
        "Empowering agriculture with innovative farming equipment solutions, enhancing productivity and sustainability for farmers.",
      Icon: Wheat,
    },
    {
      title: "Technology",
      description:
        "Guiding businesses through transformative phases with strategic support, whether it's process optimization, digitalization, or organizational restructuring.",
      Icon: Code,
    },
    {
      title: "Manufacturing",
      description:
        "Providing specialized solutions for small and medium-sized manufacturing enterprises, focusing on efficient metal fabrication processes.",
      Icon: Factory,
    },
  ];

  return (
    <section className="industries-section">
      <div className="dot-pattern top-left"></div>
      <div className="dot-pattern bottom-right"></div>
      <h2 className="industries-heading">Industries we serve</h2>
      <div className="info-row">
        {points
          .slice()
          .reverse()
          .map((item, index) => {
            const key = item.title.toLowerCase().trim();
            return (
              <div className={`info-block info-block-${key}`} key={index}>
                <item.Icon className={`info-icon info-icon-${key}`} />
                <div className={`info-content info-content-${key}`}>
                  <h3 className={`info-title info-title-${key}`}>
                    {item.title}
                  </h3>
                  <p className={`info-description info-description-${key}`}>
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
      </div>
    </section>
  );
}
